import { useDiscounts } from '~/context/common/DiscountContext';
import useGetCkPromoFromDiscounts from './useGetCkPromoFromDiscounts';

export default function useGetCkPromoFromDiscountContext(): {
  shouldShowCkPromo: boolean;
  creditKarmaPromoAmount: number;
  expirationDate: string;
} {
  const discounts = useDiscounts();

  return useGetCkPromoFromDiscounts(discounts);
}
